import React from 'react';
import ReactDOM from 'react-dom';
import AppContainer from './App';
import reportWebVitals from './reportWebVitals';
import { withLDProvider } from 'launchdarkly-react-client-sdk';
import { LAUNCH_DARKLY_CLIENT_ID } from './lib/constants/constants';
import { basicLogger } from 'launchdarkly-js-client-sdk';

const LDProvider = withLDProvider({
  clientSideID: LAUNCH_DARKLY_CLIENT_ID,
  streaming: false,
  timeout: 3,
  logger: basicLogger({
    level: 'warn',
  }),
})(AppContainer);

ReactDOM.render(
  <React.StrictMode>
    <LDProvider />
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
